import azureAuthService from './azureAuthService';
import { inspectionDB } from '../data/database.structure';
import { clearSessionCaches } from './sessionCacheReset';
import { inspectionService } from './inspection/inspection.service';

/**
 * Sign out of the app (not Microsoft) and wipe everything this user left on the device,
 * unsynced inspections included. The caller navigates to the login page afterwards.
 */
export async function signOutAndDeleteLocalData(): Promise<void> {
  await azureAuthService.logout();
  await inspectionDB.delete();
  clearSessionCaches();
  inspectionService.clearSyncState();
}
